"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get config () {
        return _config.config;
    },
    get styles () {
        return _styles.styles;
    }
});
const _config = require("./config");
const _styles = require("./styles");
